import React, { useState, useEffect,useCallback } from "react";
import api from "../services/api";
import { jwtDecode } from "jwt-decode";
import MensajeValidacion from "../components/MensajeValidacion";
const Salidas = () => {
  const [materiales, setMateriales] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [materialSeleccionado, setMaterialSeleccionado] = useState(null);
  const [usuario, setUsuario] = useState(null);
  const [categoriaId, setCategoriaId] = useState("");
  const [almacenes, setAlmacenes] = useState([]);
  
  

  // ✔ FECHA LOCAL CORREGIDA (NO UTC)
  const obtenerFechaLocal = () => {
    const hoy = new Date();
    return new Date(hoy.getTime() - hoy.getTimezoneOffset() * 60000)
      .toISOString()
      .split("T")[0];
  };

  const [form, setForm] = useState({
    fecha: obtenerFechaLocal(),
    cantidad: "",
    responsable: "",
    destino: "",
    observacion: "",
    MaterialId: "",
    AlmacenId: "",
    departamento_id: "",
  });

  const [mensaje, setMensaje] = useState({ texto: "", tipo: "", detalle: "" });
  const [guardando, setGuardando] = useState(false);
  const [departamentos, setDepartamentos] = useState([]);
  const [proyectos, setProyectos] = useState([]);
  const [proyectoId, setProyectoId] = useState("");
  const [stockDisponible, setStockDisponible] = useState(null);
  const obtenerAlmacenes = async () => {
  try {
    const res = await api.get("/almacenes");
    setAlmacenes(res.data);
  } catch (error) {
    console.error("Error al cargar almacenes:", error);
  }
};
  
  // 🔐 Obtener usuario del token
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setUsuario(decoded);

        const nombreUsuario =
          decoded.nombre || decoded.username || decoded.email || "Usuario";

        setForm((prev) => ({ ...prev, responsable: nombreUsuario }));
      } catch (error) {
        setForm((prev) => ({ ...prev, responsable: "Usuario" }));
      }
    }
  }, []);

  useEffect(() => {
    obtenerMateriales();
    obtenerCategorias();
    obtenerDepartamentos();
    obtenerProyectos();
    obtenerAlmacenes(); 
  }, []);

  

  const obtenerProyectos = async () => {
  try {
    const res = await api.get("/proyectos/activos");
    setProyectos(res.data);
  } catch (error) {
    console.error("Error al cargar proyectos:", error);
  }
};

  const obtenerDepartamentos = async () => {
  try {
    const res = await api.get("/departamentos");
    setDepartamentos(res.data);
  } catch (error) {
    console.error("Error obteniendo departamentos:", error);
  }
};

  const obtenerMateriales = async () => {
    try {
      const res = await api.get("/materiales");
      setMateriales(res.data);
    } catch (error) {
      setMensaje({ texto: "❌ Error al cargar materiales", tipo: "error" });
    }
  };

  const obtenerCategorias = async () => {
    try {
      const res = await api.get("/categorias");
      setCategorias(res.data);
    } catch (error) {
      console.error("Error al cargar categorías:", error);
    }
  };

const verificarStockDisponible = useCallback(async () => {
  if (!form.MaterialId || !form.AlmacenId) return;

  try {
    const params = {
      MaterialId: form.MaterialId,
      AlmacenId: form.AlmacenId
    };

    if (proyectoId) {
      params.ProyectoId = proyectoId;
    }

    const res = await api.get('/salidas/stock-disponible', { params });
    
    setStockDisponible(res.data);

    // Mostrar info del stock
    if (res.data.disponible) {
      console.log(`✅ Stock disponible: ${res.data.cantidad} ${res.data.material?.unidad || 'unidades'}`);
    } else {
      console.warn('⚠️ No hay stock disponible en este almacén/proyecto');
    }

  } catch (error) {
    console.error('Error al verificar stock:', error);
    setStockDisponible(null);
  }
}, [form.MaterialId, form.AlmacenId, proyectoId]);  // ✅ AGREGAR ESTO

  useEffect(() => {
  if (form.MaterialId && form.AlmacenId) {
    verificarStockDisponible();
  } else {
    setStockDisponible(null);
  }
}, [form.MaterialId, form.AlmacenId, proyectoId, verificarStockDisponible]);


  const handleMaterialChange = (materialId) => {
    const material = materiales.find((m) => m.id === parseInt(materialId));
    setMaterialSeleccionado(material);
    setForm({ ...form, MaterialId: materialId });
  };

  const registrarSalida = async () => {
  // Validaciones básicas
  if (!form.MaterialId) {
    setMensaje({ 
      texto: "⚠️ VALIDACIÓN REQUERIDA",
      detalle: "Debe seleccionar un material para continuar.",
      tipo: "error"
    });
    return;
  }

  if (!form.AlmacenId) {
    setMensaje({ 
      texto: "⚠️ VALIDACIÓN REQUERIDA",
      detalle: "Debe seleccionar un almacén de origen.",
      tipo: "error"
    });
    return;
  }

  if (!form.cantidad || parseInt(form.cantidad) <= 0) {
    setMensaje({ 
      texto: "⚠️ CANTIDAD INVÁLIDA",
      detalle: "Debe ingresar una cantidad válida mayor a cero.",
      tipo: "error"
    });
    return;
  }

  /*
  // ✅ VALIDACIÓN DE STOCK DISPONIBLE
  if (stockDisponible && !stockDisponible.disponible) {
    setMensaje({
      mensaje: "📦 SIN STOCK DISPONIBLE",
      detalle: `No hay existencias del material en el almacén seleccionado${proyectoId ? ' para el proyecto seleccionado' : ''}.`,
      material: stockDisponible.material?.nombre,
      almacen: stockDisponible.almacen?.nombre,
      cantidad_disponible: 0,
      tipo: "error",
      accion_requerida: "Verifique que el material haya sido transferido a este almacén o seleccione otro almacén."
    });
    return;
  }

  if (stockDisponible && parseFloat(stockDisponible.cantidad) < parseFloat(form.cantidad)) {
    setMensaje({
      mensaje: "📊 STOCK INSUFICIENTE",
      detalle: `La cantidad solicitada (${form.cantidad}) excede el stock disponible.`,
      material: stockDisponible.material?.nombre,
      almacen: stockDisponible.almacen?.nombre,
      cantidad_disponible: stockDisponible.cantidad,
      cantidad_solicitada: form.cantidad,
      faltante: parseFloat(form.cantidad) - parseFloat(stockDisponible.cantidad),
      tipo: "error",
      accion_requerida: `Ajuste la cantidad a ${Math.floor(stockDisponible.cantidad)} unidades o menos.`
    });
    return;
  }
*/
 
  setGuardando(true);

  try {
    const cantidadFloat = parseFloat(form.cantidad);

    const payload = {
      fecha: form.fecha,
      cantidad: cantidadFloat,
      responsable: form.responsable,
      destino: form.destino || "",
      observacion: form.observacion || "",
      MaterialId: parseInt(form.MaterialId),
      AlmacenId: parseInt(form.AlmacenId),
      departamento_id: parseInt(form.departamento_id),
    };

    if (proyectoId) {
      payload.proyectoId = parseInt(proyectoId);
    }

    const res = await api.post("/salidas", payload);

    // ✅ MOSTRAR MENSAJE DE ÉXITO CON DETALLES
  setMensaje({
  texto: res.data.mensaje || "✅ SALIDA REGISTRADA CORRECTAMENTE",  // ✅ AGREGAR
  mensaje: res.data.mensaje || "✅ SALIDA REGISTRADA CORRECTAMENTE",
  detalle: res.data.detalle || "La solicitud de salida ha sido creada y está pendiente de aprobación.",
  material: res.data.material,
  cantidad: res.data.cantidad,
  almacen: res.data.almacen,
  proyecto: res.data.proyecto,
  tipo: "success"
});

    // Reset
    setForm({
      fecha: obtenerFechaLocal(),
      cantidad: "",
      responsable: form.responsable,
      destino: "",
      observacion: "",
      MaterialId: "",
      AlmacenId: "",
      departamento_id: "",
    });

    setMaterialSeleccionado(null);
    obtenerMateriales();
    setProyectoId("");
    setStockDisponible(null);

  } catch (error) {
    console.error("❌ Error al registrar salida:", error);
    
    // ✅ MOSTRAR MENSAJE DE ERROR DEL BACKEND
    const errorData = error.response?.data;
    
   if (errorData) {
  setMensaje({
    texto: errorData.mensaje || "❌ Error al registrar la salida",  // ✅ CAMBIAR "mensaje" por "texto"
    mensaje: errorData.mensaje || "❌ Error al registrar la salida",  // ✅ AGREGAR también "mensaje"
    detalle: errorData.detalle,
    material: errorData.material,
    almacen: errorData.almacen,
    proyecto_actual: errorData.proyecto_actual,
    cantidad_disponible: errorData.cantidad_disponible,
    cantidad_solicitada: errorData.cantidad_solicitada,
    faltante: errorData.faltante,
    accion_requerida: errorData.accion_requerida,
    tipo: errorData.tipo || "error"
  });
    } else {
      setMensaje({
        texto: "❌ Error al registrar la salida",
        detalle: "Ocurrió un error inesperado. Por favor, intente nuevamente.",
        tipo: "error"
      });
    }
  } finally {
    setGuardando(false);
  }
};


  const obtenerCategoriaNombre = () => {
    if (!materialSeleccionado) return "Sin categoría";
    
    if (materialSeleccionado.categoria?.nombre) {
      return materialSeleccionado.categoria.nombre;
    }
    
    if (materialSeleccionado.Categorium?.nombre) {
      return materialSeleccionado.Categorium.nombre;
    }
    
    if (materialSeleccionado.CategoriaId) {
      const categoria = categorias.find(c => c.id === materialSeleccionado.CategoriaId);
      if (categoria?.nombre) return categoria.nombre;
    }
    
    return "Sin categoría asignada";
  };

  const obtenerCostoUnitario = () => {
    if (!materialSeleccionado) return 0;
    
    const costo = parseFloat(
      materialSeleccionado.costo_unitario_inicial || 
      materialSeleccionado.costo_unitario || 
      materialSeleccionado.valor_inicial ||
      0
    );
    
    if (costo === 0) {
      console.warn(`⚠️ Material "${materialSeleccionado.nombre}" no tiene costo asignado`);
    }
    
    return costo;
  };

  const calcularValorTotal = () => {
    if (!materialSeleccionado || !form.cantidad) return "0.00";
    
    const costoUnitario = obtenerCostoUnitario();
    const cantidad = parseFloat(form.cantidad || 0);
    const total = cantidad * costoUnitario;
    
    return total.toFixed(2);
  };

  

  return (

    <div style={styles.container}>
  <div style={styles.header}>
    <div style={{
      ...styles.headerContent,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center'
    }}>

    {/* ✅ AGREGAR AQUÍ (FUERA del div principal, DENTRO del fragment) */}
    {mensaje.texto && (
      <MensajeValidacion 
        mensaje={mensaje} 
        onClose={() => setMensaje({ texto: "", tipo: "", detalle: "" })}
      />
    )}
  
      <div>
        <h1 style={styles.title}>📤 Registrar Salida de Material</h1>
        <p style={styles.subtitle}>Registra el egreso de materiales del inventario</p>
      </div>
    </div>
  </div>

      <div style={styles.card}>
        <h3 style={styles.cardTitle}>📋 Información de la Salida</h3>

        <div style={styles.formGroup}>
  <label style={styles.label}>📁 Categoría</label>
  <select
    style={styles.select}
    value={categoriaId}
    onChange={(e) => setCategoriaId(e.target.value)}
  >
    <option value="">-- Todas las categorías --</option>
    {categorias.map((c) => (
      <option key={c.id} value={c.id}>
        {c.nombre}
      </option>
    ))}
  </select>
</div>

        <div style={styles.formGrid}>
          <div style={{ ...styles.formGroup, gridColumn: "span 2" }}>
            <label style={styles.label}>📦 Material <span style={styles.required}>*</span></label>
           <select
  style={styles.select}
  value={form.MaterialId}
  onChange={(e) => handleMaterialChange(e.target.value)}
>
  <option value="">-- Selecciona un material --</option>

  {/* NUEVO: Filtrar materiales por categoría */}
  {materiales
    .filter((m) =>
      categoriaId ? m.CategoriaId === parseInt(categoriaId) : true
    )
    .map((m) => (
      <option key={m.id} value={m.id}>
        {m.codigo} - {m.nombre} (Stock: {m.stock_actual || 0})
      </option>
    ))}
</select>
          </div>
          <div style={styles.formGroup}>
  <label style={styles.label}>
    🏢 Almacén de Origen <span style={styles.required}>*</span>
  </label>
  <select
    style={styles.select}
    value={form.AlmacenId}
    onChange={(e) => setForm({ ...form, AlmacenId: e.target.value })}
    required
  >
    <option value="">-- Selecciona almacén --</option>
    {almacenes
      .filter(a => a.activo)
      .map((alm) => (
        <option key={alm.id} value={alm.id}>
          {alm.nombre} ({alm.codigo})
        </option>
      ))}
  </select>
</div>

{stockDisponible && (
  <div style={{
    marginTop: '10px',
    padding: '12px',
    backgroundColor: stockDisponible.disponible ? '#f0fdf4' : '#fef2f2',
    border: `2px solid ${stockDisponible.disponible ? '#10b981' : '#ef4444'}`,
    borderRadius: '8px',
    fontSize: '13px'
  }}>
    {stockDisponible.disponible ? (
      <>
        <div style={{ fontWeight: 'bold', color: '#059669', marginBottom: '4px' }}>
          ✅ Stock disponible: {stockDisponible.cantidad} {stockDisponible.material?.unidad || 'unidades'}
        </div>
        {stockDisponible.proyecto && (
          <div style={{ color: '#6b7280', fontSize: '12px' }}>
            📁 Proyecto: {stockDisponible.proyecto.nombre}
          </div>
        )}
      </>
    ) : (
      <div style={{ fontWeight: 'bold', color: '#dc2626' }}>
        ⚠️ No hay stock disponible en este almacén/proyecto
      </div>
    )}
  </div>
)}

          <div style={styles.formGroup}>
            <label style={styles.label}>📅 Fecha de Salida</label>
            <input
              type="date"
              style={styles.input}
              value={form.fecha}
              onChange={(e) => setForm({ ...form, fecha: e.target.value })}
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>🔢 Cantidad <span style={styles.required}>*</span></label>
           <input
  type="number"
  step="1"         // SOLO ENTEROS
  pattern="\d*"    // BLOQUEA DECIMALES EN CELULAR
  inputMode="numeric"
  style={styles.input}
  value={form.cantidad}
  onChange={(e) => setForm({ ...form, cantidad: e.target.value })}
  required
/>
          </div>
        </div>

        {materialSeleccionado && (
          <div style={styles.infoCard}>
            <h4 style={styles.infoCardTitle}>ℹ️ Información del Material</h4>
            <div style={styles.infoGrid}>
              <div style={styles.infoItem}>
                <span style={styles.infoLabel}>Código:</span> 
                <span style={styles.infoValue}>{materialSeleccionado.codigo}</span>
              </div>
              
              <div style={styles.infoItem}>
                <span style={styles.infoLabel}>Nombre:</span> 
                <span style={styles.infoValue}>{materialSeleccionado.nombre}</span>
              </div>
              
              <div style={styles.infoItem}>
                <span style={styles.infoLabel}>Categoría:</span> 
                <span style={{
                  ...styles.infoValue,
                  color: materialSeleccionado.CategoriaId ? '#1e293b' : '#94a3b8',
                  fontStyle: materialSeleccionado.CategoriaId ? 'normal' : 'italic'
                }}>
                  {obtenerCategoriaNombre()}
                </span>
              </div>
              
              <div style={styles.infoItem}>
                <span style={styles.infoLabel}>Stock Actual:</span> 
                <span style={styles.infoValue}>
                  {materialSeleccionado.stock_actual} {materialSeleccionado.unidad}
                </span>
              </div>
              
              <div style={styles.infoItem}>
                <span style={styles.infoLabel}>Costo Unitario:</span> 
                <span style={{
                  ...styles.infoValue,
                  color: obtenerCostoUnitario() > 0 ? '#1e293b' : '#ef4444',
                  fontWeight: obtenerCostoUnitario() > 0 ? '500' : '600'
                }}>
                  {obtenerCostoUnitario() > 0 
                    ? `RD$ ${obtenerCostoUnitario().toFixed(2)}`
                    : '⚠️ Sin costo asignado'
                  }
                </span>
              </div>
              
              <div style={styles.infoItem}>
                <span style={styles.infoLabel}>Valor Estimado:</span> 
                <strong style={{
                  ...styles.infoValueStrong,
                  color: obtenerCostoUnitario() > 0 ? '#ef4444' : '#94a3b8'
                }}>
                  {obtenerCostoUnitario() > 0 
                    ? `RD$ ${calcularValorTotal()}`
                    : 'N/A'
                  }
                </strong>
              </div>
            </div>
            
            {obtenerCostoUnitario() === 0 && (
              <div style={styles.warningBox}>
                ⚠️ Este material no tiene costo unitario registrado. El valor total no se calculará.
              </div>
            )}
          </div>
        )}

        <div style={styles.formGrid}>
          <div style={styles.formGroup}>
            <label style={styles.label}>👤 Responsable</label>
            <input
              type="text"
              style={{ ...styles.input, backgroundColor: "#f1f5f9" }}
              value={form.responsable}
              readOnly
            />
          </div>
<div style={styles.formGroup}>
  <label style={styles.label}>🏢 Departamento</label>
  <select
    style={styles.select}
    value={form.departamento_id}  // ✅ Esto es el ID
    onChange={(e) => {
      const selectedId = e.target.value;
      const selectedDept = departamentos.find(d => d.id == selectedId);
      setForm({ 
        ...form, 
        departamento_id: selectedId,  // ✅ Guarda el ID
        destino: selectedDept ? selectedDept.nombre : ""  // ✅ Guarda el nombre para mostrar
      });
    }}
  >
    <option value="">Seleccione un departamento</option>
    {departamentos.map((d) => (
      <option key={d.id} value={d.id}>  {/* ✅ value={d.id} pero muestra {d.nombre} */}
        {d.nombre}
      </option>
    ))}
  </select>
</div>
        </div>
 {proyectos.length > 0 && (
  <div style={styles.formGroup}>
    <label style={styles.label}>🏗️ Proyecto (Opcional)</label>
    <select
      style={styles.select}
      value={proyectoId || ""}  // ← Cambio aquí
      onChange={(e) => setProyectoId(e.target.value)}
    >
      <option value="">-- Seleccionar proyecto --</option>
      {proyectos.map((p) => (
        <option key={p.id} value={p.id}>
          {p.nombre}
        </option>
      ))}
    </select>
  </div>
)}


        <div style={styles.formGroup}>
          <label style={styles.label}>📝 Observación</label>
          <textarea
            style={{ ...styles.input, minHeight: "80px", resize: "vertical" }}
            placeholder="Notas adicionales (opcional)"
            value={form.observacion}
            onChange={(e) => setForm({ ...form, observacion: e.target.value })}
          />
        </div>

        <div style={styles.actions}>
          <button
            style={{ ...styles.btnSave, opacity: guardando ? 0.6 : 1 }}
            onClick={registrarSalida}
            disabled={guardando}
          >
            {guardando ? "Registrando..." : "💾 Registrar Salida"}
          </button>
        </div>

        {mensaje.texto && (
          <div
            style={{
              ...styles.message,
              ...(mensaje.tipo === "success"
                ? styles.messageSuccess
                : mensaje.tipo === "warning"
                ? styles.messageWarning
                : mensaje.tipo === "info"
                ? styles.messageInfo
                : styles.messageError),
            }}
          >
            {mensaje.texto.split('\n').map((linea, i) => (
              <div key={i}>{linea}</div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    background: '#f8fafc',
    padding: '20px',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },
  header: {
    marginBottom: '25px',
  },
  headerContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '20px',
  },
  title: {
    fontSize: '28px',
    fontWeight: '700',
    color: '#1e293b',
    margin: '0 0 5px 0',
  },
  subtitle: {
    fontSize: '14px',
    color: '#64748b',
    margin: '0',
  },
  importSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: '10px',
  },
  fileInput: {
    padding: '8px 12px',
    fontSize: '13px',
    border: '1px solid #cbd5e1',
    borderRadius: '8px',
    background: 'white',
    cursor: 'pointer',
  },
  btnImport: {
    padding: '12px 24px',
    background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
    color: 'white',
    border: 'none',
    borderRadius: '10px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    boxShadow: '0 4px 12px rgba(16, 185, 129, 0.3)',
    whiteSpace: 'nowrap',
  },
  fileName: {
    fontSize: '12px',
    color: '#64748b',
    fontStyle: 'italic',
  },
  card: {
    background: 'white',
    borderRadius: '12px',
    padding: '30px',
    marginBottom: '20px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
    border: '1px solid #e2e8f0',
    maxWidth: '900px',
    margin: '0 auto 20px auto',
  },
  cardTitle: {
    fontSize: '18px',
    fontWeight: '700',
    color: '#1e293b',
    margin: '0 0 25px 0',
  },
  formGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '20px',
    marginBottom: '25px',
  },
  formGroup: {
    display: 'flex',
    flexDirection: 'column',
  },
  label: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    fontSize: '13px',
    fontWeight: '600',
    color: '#475569',
    marginBottom: '8px',
  },
  required: {
    color: '#e74c3c',
    fontWeight: 'bold',
  },
  input: {
    padding: '10px 12px',
    fontSize: '14px',
    border: '1px solid #cbd5e1',
    borderRadius: '8px',
    outline: 'none',
    transition: 'all 0.2s ease',
  },
  select: {
    padding: '10px 12px',
    fontSize: '14px',
    border: '1px solid #cbd5e1',
    borderRadius: '8px',
    outline: 'none',
    background: 'white',
    cursor: 'pointer',
  },
  infoCard: {
    background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
    borderRadius: '12px',
    padding: '20px',
    marginBottom: '25px',
  },
  infoCardTitle: {
    fontSize: '15px',
    fontWeight: '700',
    color: '#1e293b',
    marginBottom: '15px',
    margin: '0 0 15px 0',
  },
  infoGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: '12px',
  },
  infoItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px 12px',
    background: 'rgba(255, 255, 255, 0.7)',
    borderRadius: '6px',
    fontSize: '13px',
  },
  infoLabel: {
    fontWeight: '600',
    color: '#475569',
  },
  infoValue: {
    color: '#1e293b',
    fontWeight: '500',
  },
  infoValueStrong: {
    color: '#ef4444',
    fontWeight: '700',
    fontSize: '14px',
  },
  warningBox: {
    marginTop: '15px',
    padding: '12px 15px',
    background: '#fef3c7',
    border: '1px solid #fbbf24',
    borderRadius: '8px',
    fontSize: '13px',
    color: '#78350f',
    fontWeight: '500',
  },
  actions: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '25px',
  },
  btnSave: {
    padding: '14px 40px',
    background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
    color: 'white',
    border: 'none',
    borderRadius: '10px',
    fontSize: '15px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    boxShadow: '0 4px 12px rgba(239, 68, 68, 0.3)',
  },
  message: {
    padding: '12px 20px',
    borderRadius: '8px',
    marginTop: '20px',
    fontSize: '14px',
    fontWeight: '500',
    textAlign: 'center',
  },
  messageSuccess: {
    background: '#d1fae5',
    color: '#065f46',
    border: '1px solid #10b981',
  },
  messageError: {
    background: '#fee2e2',
    color: '#991b1b',
    border: '1px solid #ef4444',
  },
  messageWarning: {
    background: '#fef3c7',
    color: '#78350f',
    border: '1px solid #fbbf24',
  },
  messageInfo: {
    background: '#dbeafe',
    color: '#1e3a8a',
    border: '1px solid #3b82f6',
  },
};



export default Salidas;